module.exports = __webpack_public_path__ + "static/media/loc4_img2.3ec6aa2d.jpg";